export default "/assets/website/images/pwd-hide.svg?2f4ef07666f0025058ba907e60816676";